import React from "react";
import MembersGroupListItem from "../../components/membersGroup/MembersGroupList/MembersGroupListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const MembersGroupListPage = ()  => {

    useTitle(t`List Members Group`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <MembersGroupListItem showAdd={true} {...query} />
        </Box>
    )
}

export default MembersGroupListPage;
